<div class="row mb-4" [hidden]="hidden" [formGroup]="formGroup!">

    <label class="col-sm-2 col-form-label form-label">
        {{field.label}}
        <span class="text-danger" *ngIf="field.required"> * </span>
    </label> 

    <div class="col-sm-10">

        <p-calendar *ngIf="field.textFieldType=='date'" formControlName="{{fieldId}}" [(ngModel)]="date" dateFormat="yy/mm/dd"  [ngClass]="isInvalid && submitted ? 'ng-invalid ng-dirty':null"   [required]="field.required && !field.hidden!" (onSelect)="refreshForm(field.id,field.shouldRefresh,containerFieldId,fieldIndex,isContainer)"  />

        <input *ngIf="field.textFieldType!='textArea' && field.textFieldType!='date'"  [style]="{'direction':field.textDirection??'rtl'}" [pattern]="field.regex || '^[^<>]*$'" (change)="updateIsUserType()" class="form-control" [readOnly]="!field.editable"  [ngClass]="isInvalid && submitted ? 'is-invalid':null"  formControlName="{{fieldId}}" [type]="getTextFieldType(field.textFieldType!)" [required]="field.required && !field.hidden!" (blur)="refreshForm(field.id,field.shouldRefresh,containerFieldId,fieldIndex,isContainer)">
        
        <textarea *ngIf="field.textFieldType=='textArea'" class="form-control" cols="30" rows="5" [readOnly]="!field.editable"  [ngClass]="isInvalid && submitted ? 'is-invalid':null" formControlName="{{fieldId}}" [pattern]="field.regex || '^[^<>]*$'" [required]="field.required && !field.hidden!" (blur)="refreshForm(field.id,field.shouldRefresh,containerFieldId,fieldIndex,isContainer)"></textarea>

        <p class="pt-1" style="font-size: 13px !important;" *ngIf="field?.description">
            {{field.description}}
        </p>

        <p class="pt-1 text-danger" style="font-size: 13px !important;" *ngIf="yourTurn && field?.approved == false">
            {{field.comment}}
        </p>

        <div *ngIf="isInvalid && submitted">
            <span class="text-danger" *ngIf="errors?.['required']">
                {{'requiredField'|translate}}!
            </span>

            <span class="text-danger" *ngIf="errors?.['pattern']">
               صيعة الحقل غير صحيحة! 
            </span>
        </div>
    </div>
</div>